import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = ["innerHTML"];
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "100%",
    "height": "100%",
    "border-bottom": "none",
    "border-radius": "0"
  }
}, null, -1);
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  style: {
    "display": "flex",
    "height": "100%",
    "gap": "8px",
    "align-self": "stretch"
  }
};
const _hoisted_7 = {
  class: "dsp-popover-content"
};
const _hoisted_8 = {
  class: "title-and-value"
};
const _hoisted_9 = {
  class: "details"
};
const _hoisted_10 = {
  class: "detail-title-and-value-container"
};
const _hoisted_11 = {
  class: "detail-title-and-value"
};
const _hoisted_12 = {
  class: "detail-title"
};
const _hoisted_13 = {
  class: "detail-title"
};
const _hoisted_14 = {
  class: "detail-title-and-value"
};
const _hoisted_15 = {
  class: "detail-title"
};
const _hoisted_16 = {
  class: "detail-title"
};
const _hoisted_17 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_18 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_19 = {
  class: "dsp-popover-content"
};
const _hoisted_20 = {
  class: "title-and-value"
};
const _hoisted_21 = {
  class: "details"
};
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EDF5FF',
    zIndex: '0'
  }
}, null, -1);
const _hoisted_23 = {
  class: "detail-title-and-value-container"
};
const _hoisted_24 = {
  class: "detail-title-and-value"
};
const _hoisted_25 = {
  class: "detail-title"
};
const _hoisted_26 = {
  class: "detail-title"
};
const _hoisted_27 = {
  class: "detail-title-and-value"
};
const _hoisted_28 = {
  class: "detail-title"
};
const _hoisted_29 = {
  class: "detail-title"
};
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EDF5FF',
    zIndex: '0'
  }
}, null, -1);
const _hoisted_31 = {
  class: "dsp-popover-content"
};
const _hoisted_32 = {
  class: "title-and-value"
};
const _hoisted_33 = {
  class: "details"
};
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EAF6F6'
  }
}, null, -1);
const _hoisted_35 = {
  class: "detail-title-and-value-container"
};
const _hoisted_36 = {
  class: "detail-title-and-value"
};
const _hoisted_37 = {
  class: "detail-title"
};
const _hoisted_38 = {
  class: "detail-title"
};
const _hoisted_39 = {
  class: "detail-title-and-value"
};
const _hoisted_40 = {
  class: "detail-title"
};
const _hoisted_41 = {
  class: "detail-title"
};
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", {
  class: "bar-background",
  style: {
    flex: '1 0 0',
    borderRadius: '4px',
    height: '4px',
    background: '#EAF6F6'
  }
}, null, -1);
const _hoisted_43 = /*#__PURE__*/_createElementVNode("div", null, "VTR below 70%", -1);
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", null, "Check viewability threshold in line item settings", -1);
const _hoisted_45 = {
  class: "dsp-popover-content"
};
const _hoisted_46 = {
  class: "title-and-value"
};
const _hoisted_47 = {
  class: "details"
};
const _hoisted_48 = {
  class: "detail-title-and-value-container"
};
const _hoisted_49 = {
  class: "detail-title-and-value"
};
const _hoisted_50 = {
  class: "detail-title"
};
const _hoisted_51 = {
  class: "detail-title"
};
const _hoisted_52 = {
  class: "detail-title-and-value"
};
const _hoisted_53 = {
  class: "detail-title"
};
const _hoisted_54 = {
  class: "detail-title"
};
const _hoisted_55 = {
  class: "detail-title-and-value"
};
const _hoisted_56 = {
  class: "detail-title"
};
const _hoisted_57 = {
  class: "detail-title"
};
const _hoisted_58 = {
  class: "detail-title-and-value"
};
const _hoisted_59 = {
  class: "detail-title"
};
const _hoisted_60 = {
  class: "detail-title"
};
const _hoisted_61 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_62 = {
  style: {
    "text-align": "center"
  }
};
const _hoisted_63 = {
  class: "dsp-popover-content"
};
const _hoisted_64 = {
  class: "title-and-value"
};
const _hoisted_65 = {
  class: "details"
};
const _hoisted_66 = {
  class: "detail-title-and-value-container"
};
const _hoisted_67 = {
  class: "detail-title-and-value"
};
const _hoisted_68 = {
  class: "detail-title"
};
const _hoisted_69 = {
  class: "detail-title"
};
const _hoisted_70 = {
  class: "detail-title-and-value"
};
const _hoisted_71 = {
  class: "detail-title"
};
const _hoisted_72 = {
  class: "detail-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_table_group_by = _resolveComponent("product-table-group-by");
  const _component_b_th = _resolveComponent("b-th");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_tr = _resolveComponent("b-tr");
  const _component_wrap_with_arrow = _resolveComponent("wrap-with-arrow");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_flex_row = _resolveComponent("flex-row");
  const _component_product_table_total = _resolveComponent("product-table-total");
  const _component_value_element = _resolveComponent("value-element");
  const _component_marketplace_value = _resolveComponent("marketplace-value");
  const _component_dot_element = _resolveComponent("dot-element");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_bar_with_value = _resolveComponent("bar-with-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_overlap_bar_value = _resolveComponent("overlap-bar-value");
  const _component_boxed_value = _resolveComponent("boxed-value");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_b_table_lite = _resolveComponent("b-table-lite");
  const _component_floating_compound_table = _resolveComponent("floating-compound-table");
  return _openBlock(), _createBlock(_component_floating_compound_table, {
    ref: "performanceFloatingCompoundTable",
    datePickerDate: $options.datePickerDate,
    loading: $props.loading,
    onChangeDate: $options.handleDatePickerSubmit,
    onTableState: $options.handleTableState,
    page: $options.page,
    "onUpdate:page": _cache[0] || (_cache[0] = $event => $options.page = $event),
    totalPages: $options.totalPages,
    "onUpdate:totalPages": _cache[1] || (_cache[1] = $event => $options.totalPages = $event),
    perPage: $options.perPage,
    "onUpdate:perPage": _cache[2] || (_cache[2] = $event => $options.perPage = $event),
    style: {
      ['--compound-table-right-gap']: '16px'
    },
    fields: $options.fields,
    selectedPeriod: _ctx.period
  }, {
    header: _withCtx(() => [_createTextVNode("Breakdown by")]),
    "header-sub": _withCtx(() => [_createVNode(_component_product_table_group_by, {
      onRefresh: $options.handleGroupByRefresh,
      onClicked: $options.handleClicked,
      tabBusy: $props.loading
    }, null, 8, ["onRefresh", "onClicked", "tabBusy"])]),
    table: _withCtx(({
      fullSize,
      visible
    }) => [_createVNode(_component_b_table_lite, {
      class: _normalizeClass(['lite-table', 'dsp-product-table', {
        ['full-size']: fullSize
      }, {
        ['intermediate']: !fullSize && visible
      }, _ctx.groupBy]),
      style: _normalizeStyle(_ctx.cssProps),
      items: $options.filteredItems,
      fields: $options.fields,
      responsive: "",
      fixed: "",
      "sticky-header": "",
      bordered: "",
      "no-border-collapse": "",
      tbodyTrClass: item => $options.getTbodyTrClass(item),
      onHeadClicked: $options.handleHeadClick,
      onRowClicked: $options.handleRowClick,
      fieldColumnClass: field => $options.getThClass(field)
    }, {
      "thead-top": _withCtx(() => [_createVNode(_component_b_tr, {
        class: "headers"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_th, {
          colspan: "1",
          "sticky-column": ""
        }), _createVNode(_component_b_th, {
          colspan: "1",
          class: "objective left-embrace right-embrace",
          style: {
            color: '#BE510E',
            background: '#FFF1E9'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Objective")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: "2",
          class: "efficiency left-embrace right-embrace",
          style: {
            color: '#5B4806',
            background: '#FFFAED'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Efficiency")]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_b_th, {
          colspan: {
            conversion: 4,
            consideration: 3,
            loyalty: 4
          }[_ctx.currentTabValue],
          class: "business_results left-embrace right-embrace",
          style: {
            color: '#134890',
            background: '#F4F8FF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Business Results")]),
            _: 1
          })]),
          _: 1
        }, 8, ["colspan"]), _createVNode(_component_b_th, {
          colspan: {
            conversion: 5,
            consideration: 1,
            loyalty: 5
          }[_ctx.currentTabValue],
          class: "brand_interest left-embrace right-embrace",
          style: {
            color: '#5A52AE',
            background: '#F8F9FF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Brand Interest")]),
            _: 1
          })]),
          _: 1
        }, 8, ["colspan"]), _createVNode(_component_b_th, {
          colspan: {
            conversion: 3,
            consideration: 3,
            loyalty: 3
          }[_ctx.currentTabValue],
          class: "delivery_quality left-embrace right-embrace",
          style: {
            color: '#348371',
            background: '#ECF9F6'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Delivery Quality")]),
            _: 1
          })]),
          _: 1
        }, 8, ["colspan"]), _createVNode(_component_b_th, {
          colspan: {
            conversion: 5,
            consideration: 3,
            loyalty: 5
          }[_ctx.currentTabValue],
          class: "control left-embrace right-embrace",
          style: {
            color: '#626262',
            background: '#EFEFEF'
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_hug_value, null, {
            default: _withCtx(() => [_createTextVNode("Control")]),
            _: 1
          })]),
          _: 1
        }, 8, ["colspan"])]),
        _: 1
      })]),
      "head()": _withCtx(col => [_createVNode(_component_flex_row, {
        id: `product-table-${col?.column}`,
        styles: {
          justifyContent: col.field.justify,
          ...col.field.thStyle
        },
        onClick: $event => $options.handleHeadClick(col.field.key)
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          target: `product-table-${col?.column}`
        }, {
          title: _withCtx(() => [_createElementVNode("div", {
            innerHTML: $options.getDescriptionBasedOnKpiKey(col?.column).title
          }, null, 8, _hoisted_1)]),
          content: _withCtx(() => [_createTextVNode(_toDisplayString($options.getDescriptionBasedOnKpiKey(col?.column).detail), 1)]),
          default: _withCtx(() => [['asc', 'desc'].includes(this.sort[$options.fieldKeyMap[col?.column]]) ? (_openBlock(), _createBlock(_component_wrap_with_arrow, {
            key: 0,
            direction: this.sort[$options.fieldKeyMap[col?.column]]
          }, {
            default: _withCtx(() => [_createElementVNode("div", {
              class: "title",
              innerHTML: col?.label
            }, null, 8, _hoisted_2)]),
            _: 2
          }, 1032, ["direction"])) : (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "title",
            innerHTML: col?.label
          }, null, 8, _hoisted_3))]),
          _: 2
        }, 1032, ["target"])]),
        _: 2
      }, 1032, ["id", "styles", "onClick"])]),
      "custom-foot": _withCtx(() => [_createElementVNode("tr", null, [_createVNode(_component_product_table_total, {
        fields: $options.fields,
        total: $options.total,
        currencyConfig: _ctx.currencyConfig,
        loading: $props.loading,
        evolutionType: _ctx.evolutionType
      }, null, 8, ["fields", "total", "currencyConfig", "loading", "evolutionType"])])]),
      "bottom-row": _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.fields, (field, index) => {
        return _openBlock(), _createElementBlock("td", {
          key: index,
          class: _normalizeClass(['bottom-row', {
            'b-table-sticky-column': field.stickyColumn
          }, field.class])
        }, _hoisted_5, 2);
      }), 128))]),
      "cell(seller_name)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_value_element, {
          value: row.item?.seller_name
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(sales_channel)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createVNode(_component_marketplace_value, {
          marketplace: row.item?.sales_channel,
          flag: _ctx.getCountryFlag($data.country_code_amz_sp_api_marketplace_ids_flipped[$data.amz_sp_api_marketplace_ids_country_domains_flipped[row.item?.sales_channel?.toLowerCase()]])
        }, null, 8, ["marketplace", "flag"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(order_id)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left",
        tight: ""
      }, {
        default: _withCtx(() => [_createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(row.item?.order_name), 1)]),
          default: _withCtx(() => [_createVNode(_component_value_element, {
            value: $options.truncateString(row.item?.order_name, 30)
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(line_item_id)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        align: "left"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createVNode(_component_dot_element, {
          size: 8,
          color: row.item?.line_item_status === 'RUNNING' ? '#47D16C' : row.item?.line_item_status === 'PAUSED_BY_USER' ? '#FD6' : '#F07A80',
          style: {
            "align-self": "center"
          }
        }, null, 8, ["color"]), _createVNode(_component_wrap_with_popover, {
          width: "fit-content",
          placement: "top"
        }, {
          title: _withCtx(() => [_createTextVNode(_toDisplayString(row.item?.line_item_name), 1)]),
          default: _withCtx(() => [_createVNode(_component_value_element, {
            value: $options.truncateString(row.item?.line_item_name, 30),
            style: {
              "align-self": "center"
            }
          }, null, 8, ["value"])]),
          _: 2
        }, 1024)])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_new_customers)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        delay: {
          show: 0,
          hide: 100
        },
        width: 230,
        padding: "8px",
        class: "raos_vs_target_popover",
        customClass: "dsp-popover"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createTextVNode(" New Customers "), _createVNode(_component_currency_value, {
          value: row.item?.conversion_new_customers,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.conversion_new_customers,
          precision: row.item?.conversion_new_customers > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_9, [_createVNode(_component_bar_with_value, {
          value: row.item?.conversion_sns,
          min: Math.min($options.minMax?.conversion_new_customers?.min, $options.minMax?.conversion_sns?.min),
          color: "#F89053",
          max: $options.minMax?.conversion_new_customers?.max,
          loading: $props.loading,
          height: 15,
          tight: "",
          style: {
            "width": "100%"
          }
        }, {
          "bar-append": _withCtx(() => [_createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.conversion_ntb_purchase / $options.minMax?.conversion_new_customers?.max * 100 ?? 0}%`,
              borderRadius: '0 4px 4px 0',
              height: '15px',
              background: '#FFE9DB'
            })
          }, null, 4)]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"]), _createElementVNode("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createVNode(_component_dot_element, {
          color: "#F89053",
          size: 8
        }), _createTextVNode(" SnS customers ")]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_currency_value, {
          value: row.item?.conversion_sns,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.conversion_sns,
          precision: row.item?.conversion_sns > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_dot_element, {
          color: "#FFE9DB",
          size: 8
        }), _createTextVNode(" Single purchase ")]), _createElementVNode("div", _hoisted_16, [_createVNode(_component_currency_value, {
          value: row.item?.conversion_ntb_purchase,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.conversion_ntb_purchase,
          precision: row.item?.conversion_ntb_purchase > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])])])])])]),
        default: _withCtx(() => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`],
                charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`],
                align: "right",
                tight: "",
                color: color
              }, null, 8, ["value", "charCount", "color"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.conversion_sns,
              min: Math.min($options.minMax?.conversion_new_customers?.min, $options.minMax?.conversion_sns?.min),
              color: "#F89053",
              max: $options.minMax?.conversion_new_customers?.max,
              loading: $props.loading,
              height: 15,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_createElementVNode("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.conversion_ntb_purchase / $options.minMax?.conversion_new_customers?.max * 100 ?? 0}%`,
                  borderRadius: '0 4px 4px 0',
                  height: '15px',
                  background: '#FFE9DB'
                })
              }, null, 4)]),
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.conversion_new_customers,
                loading: $props.loading,
                showSymbol: false,
                align: "right",
                allowPrecisionModification: false,
                charCount: $options.maxCharCount?.currency?.conversion_new_customers,
                precision: row.item?.conversion_new_customers > 1000000 ? 1 : 0
              }, null, 8, ["value", "loading", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_roas_vs_target)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        target: `roas_vs_target_${row.item?.period_agg}`,
        width: 124,
        padding: "8px",
        class: "raos_vs_target_popover"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_17, "Target ROAS: " + _toDisplayString(row.item?.[`${_ctx.currentTabValue}_target`]), 1)]),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_18, _toDisplayString(row.item?.[`${_ctx.currentTabValue}_target`] > row.item?.[`${_ctx.currentTabValue}_roas`] ? 'Below Target' : 'Above Target'), 1)]),
        default: _withCtx(() => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "position": "relative"
          },
          id: `roas_vs_target_${row.item?.period_agg}`
        }, {
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.[`${_ctx.currentTabValue}_roas`],
            background: "",
            borderColor: `${row.item?.[`${_ctx.currentTabValue}_roas`] >= row.item?.[`${_ctx.currentTabValue}_target`] ? '#DEFBE6' : '#FFF0F1'}`,
            min: 0,
            max: Math.max($options.minMax?.[`${_ctx.currentTabValue}_roas`]?.max, $options.minMax?.[`${_ctx.currentTabValue}_target`]?.max),
            loading: $props.loading,
            align: "left",
            barStyles: {
              borderRight: `${row.item?.[`${_ctx.currentTabValue}_roas`] >= row.item?.[`${_ctx.currentTabValue}_target`] ? '1.2px solid #22863D ' : '1.2px solid #E7747A'}`,
              borderRadius: '4px',
              height: '20px',
              background: `${row.item?.[`${_ctx.currentTabValue}_roas`] >= row.item?.[`${_ctx.currentTabValue}_target`] ? '#DEFBE6' : '#FFF0F1'}`
            },
            style: {
              "width": "100%",
              "position": "absolute",
              "z-index": "1"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.[`${_ctx.currentTabValue}_roas`],
              charCount: $options.maxCharCount?.number?.[`${_ctx.currentTabValue}_roas`],
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "borderColor", "max", "loading", "barStyles"]), _createVNode(_component_overlap_bar_value, {
            value: row.item?.[`${_ctx.currentTabValue}_target`],
            background: "",
            borderColor: "#E3E3E3",
            min: 0,
            max: Math.max($options.minMax?.[`${_ctx.currentTabValue}_target`]?.max, $options.minMax?.[`${_ctx.currentTabValue}_target`]?.max),
            loading: $props.loading,
            align: "left",
            barStyles: {
              borderRight: 'none',
              borderRadius: '4px',
              height: '20px',
              background: '#E3E3E3'
            },
            style: {
              "width": "100%",
              "position": "absolute"
            }
          }, null, 8, ["value", "max", "loading"])]),
          _: 2
        }, 1032, ["loading", "id"])]),
        _: 2
      }, 1032, ["target"])]),
      "cell(dsp_cpa_conversion)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "right",
          value: row.item?.conversion_cpa_ntb,
          precision: 2,
          charCount: $options.maxCharCount?.currency?.conversion_cpa_ntb + 2
        }, null, 8, ["value", "charCount"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_spend)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_spend`],
        background: "",
        borderColor: "#E0ECFF",
        min: Math.min($options.minMax?.[`${_ctx.currentTabValue}_spend`]?.min, _ctx.currentTabValue === 'consideration' ? $options.minMax.consideration_dpv?.min : $options.minMax?.[`${_ctx.currentTabValue}_assisted_sales`]?.min),
        max: Math.max($options.minMax?.[`${_ctx.currentTabValue}_spend`]?.max, _ctx.currentTabValue === 'consideration' ? $options.minMax.consideration_dpv?.max : $options.minMax?.[`${_ctx.currentTabValue}_assisted_sales`]?.max),
        loading: $props.loading,
        align: "right",
        styles: {
          padding: '0 1px 0 8px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#E0ECFF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_spend`],
          loading: $props.loading,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_spend`],
          precision: row.item?.[`${_ctx.currentTabValue}_spend`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_assisted_sales)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_assisted_sales`],
        background: "",
        borderColor: "#ADCDFF",
        min: Math.min($options.minMax?.[`${_ctx.currentTabValue}_spend`]?.min, $options.minMax?.[`${_ctx.currentTabValue}_assisted_sales`]?.min),
        max: Math.max($options.minMax?.[`${_ctx.currentTabValue}_spend`]?.max, $options.minMax?.[`${_ctx.currentTabValue}_assisted_sales`]?.max),
        loading: $props.loading,
        align: "left",
        styles: {
          padding: '0 8px 0 1px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#ADCDFF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_assisted_sales`],
          loading: $props.loading,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_assisted_sales`],
          precision: row.item?.[`${_ctx.currentTabValue}_assisted_sales`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_percent_assisted_sales)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        delay: {
          show: 0,
          hide: 100
        },
        width: 230,
        padding: "8px",
        class: "raos_vs_target_popover",
        customClass: "dsp-popover"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", _hoisted_20, [_createTextVNode(" % of Assisted sales "), _createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`] + row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`],
          loading: $props.loading,
          charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`]
        }, null, 8, ["value", "loading", "charCount"])]), _createElementVNode("div", _hoisted_21, [_createVNode(_component_bar_with_value, {
          value: row.item?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`],
          min: 0,
          color: "#8AB4FF",
          max: 1,
          loading: $props.loading,
          style: {
            "width": "100%"
          }
        }, {
          "bar-append": _withCtx(() => [_createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`] * 100}%`,
              borderRadius: ' 0 4px 4px 0',
              height: '4px',
              background: '#2172E1',
              // marginLeft: '-1px',
              display: `${Math.round(row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`] * 100) > 0 ? 'block' : 'none'}`,
              zIndex: '2'
            })
          }, null, 4), _hoisted_22]),
          _: 2
        }, 1032, ["value", "loading"]), _createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_createVNode(_component_dot_element, {
          color: "#8AB4FF",
          size: 8
        }), _createTextVNode(" Main products ")]), _createElementVNode("div", _hoisted_26, [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`],
          charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`]
        }, null, 8, ["value", "charCount"])])]), _createElementVNode("div", _hoisted_27, [_createElementVNode("div", _hoisted_28, [_createVNode(_component_dot_element, {
          color: "#2172E1",
          size: 8
        }), _createTextVNode(" Halo products ")]), _createElementVNode("div", _hoisted_29, [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`],
          charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`]
        }, null, 8, ["value", "charCount"])])])])])])]),
        default: _withCtx(() => [_createVNode(_component_bar_with_value, {
          value: row.item?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`],
          min: 0,
          color: "#8AB4FF",
          max: 1,
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          "bar-append": _withCtx(() => [_createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`] * 100}%`,
              width: '1%',
              borderRadius: ' 0 4px 4px 0',
              height: '4px',
              background: '#2172E1',
              marginLeft: '-1px',
              display: `${Math.round(row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`] * 100) > 0 ? 'block' : 'none'}`,
              zIndex: '2'
            })
          }, null, 4), _hoisted_30]),
          default: _withCtx(() => [_createVNode(_component_percentage_value, {
            value: row.item?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`] + row.item?.[`${_ctx.currentTabValue}_pct_halo_assisted_sales`],
            loading: $props.loading,
            charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_pct_main_assisted_sales`]
          }, null, 8, ["value", "loading", "charCount"])]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_units_sold)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
          gap: 8
        }, {
          evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
            value: row.item?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: row.item?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              align: "right",
              tight: "",
              color: color
            }, null, 8, ["value", "charCount", "color"])]),
            _: 2
          }, 1032, ["value"])]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.[`${_ctx.currentTabValue}_units_sold`],
            loading: $props.loading,
            showSymbol: false,
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_units_sold`],
            precision: row.item?.[`${_ctx.currentTabValue}_units_sold`] > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1024)]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_atc_clicks)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_atc_clicks`],
        background: "",
        borderColor: "#E8DAFF",
        min: $options.minMax?.[`${_ctx.currentTabValue}_atc_clicks`]?.min,
        max: $options.minMax?.[`${_ctx.currentTabValue}_atc_clicks`]?.max,
        loading: $props.loading,
        align: "right",
        styles: {
          padding: '0 1px 0 8px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#E8DAFF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_atc_clicks`],
          loading: $props.loading,
          showSymbol: false,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_atc_clicks`],
          precision: row.item?.[`${_ctx.currentTabValue}_atc_clicks`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_atc_views)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_atc_views`],
        background: "",
        borderColor: "#F6F2FF",
        min: $options.minMax?.[`${_ctx.currentTabValue}_atc_views`]?.min,
        max: $options.minMax?.[`${_ctx.currentTabValue}_atc_views`]?.max,
        loading: $props.loading,
        align: "left",
        styles: {
          padding: '0 8px 0 1px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#F6F2FF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_atc_views`],
          loading: $props.loading,
          showSymbol: false,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_atc_views`],
          precision: row.item?.[`${_ctx.currentTabValue}_atc_views`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_dpv_clicks)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_dpv_clicks`],
        background: "",
        borderColor: "#E8DAFF",
        min: $options.minMax?.[`${_ctx.currentTabValue}_dpv_clicks`]?.min,
        max: $options.minMax?.[`${_ctx.currentTabValue}_dpv_clicks`]?.max,
        loading: $props.loading,
        align: "right",
        styles: {
          padding: '0 1px 0 8px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#E8DAFF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_dpv_clicks`],
          loading: $props.loading,
          showSymbol: false,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_dpv_clicks`],
          precision: row.item?.[`${_ctx.currentTabValue}_dpv_clicks`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_dpv_views)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_dpv_views`],
        background: "",
        borderColor: "#F6F2FF",
        min: $options.minMax?.[`${_ctx.currentTabValue}_dpv_views`]?.min,
        max: $options.minMax?.[`${_ctx.currentTabValue}_dpv_views`]?.max,
        loading: $props.loading,
        align: "left",
        styles: {
          padding: '0 8px 0 1px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#F6F2FF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_dpv_views`],
          loading: $props.loading,
          showSymbol: false,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_dpv_views`],
          precision: row.item?.[`${_ctx.currentTabValue}_dpv_views`] > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_brand_searches)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.[`${_ctx.currentTabValue}_brand_searches`],
        background: "",
        borderColor: "#F8F9FF",
        min: $options.minMax?.[`${_ctx.currentTabValue}_brand_searches`]?.min,
        max: $options.minMax?.[`${_ctx.currentTabValue}_brand_searches`]?.max,
        loading: $props.loading,
        align: "left",
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#F8F9FF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "left",
          value: row.item?.[`${_ctx.currentTabValue}_brand_searches`],
          loading: $props.loading,
          showSymbol: false,
          align: "left",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_brand_searches`],
          precision: row.item?.[`${_ctx.currentTabValue}_brand_searches`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_ecpm)": _withCtx(row => [_createVNode(_component_boxed_value, {
        bgColor: $options.getColorForDecile(row.item?.[`${_ctx.currentTabValue}_ecpm`], $options.minMax?.[`${_ctx.currentTabValue}_ecpm`]?.min, $options.minMax?.[`${_ctx.currentTabValue}_ecpm`]?.max, $data.ECPM_DECILE_COLORS, 5, 4),
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_ecpm`],
          precision: 2
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["bgColor", "loading"])]),
      "cell(dsp_impressions)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        delay: {
          show: 0,
          hide: 100
        },
        width: 230,
        padding: "8px",
        class: "raos_vs_target_popover",
        customClass: "dsp-popover"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", _hoisted_32, [_createTextVNode(" Impressions "), _createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`],
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_viewable_impressions`],
          precision: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_33, [_createVNode(_component_bar_with_value, {
          value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] / (row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`]),
          min: 0,
          color: "#1EBDBD",
          max: 1,
          loading: $props.loading,
          style: {
            "width": "100%"
          }
        }, {
          "bar-append": _withCtx(() => [_hoisted_34]),
          _: 2
        }, 1032, ["value", "loading"]), _createElementVNode("div", _hoisted_35, [_createElementVNode("div", _hoisted_36, [_createElementVNode("div", _hoisted_37, [_createVNode(_component_dot_element, {
          color: "#1EBDBD",
          size: 8
        }), _createTextVNode(" Viewable impre. ")]), _createElementVNode("div", _hoisted_38, [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`],
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_viewable_impressions`],
          precision: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"]), _createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] / (row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_viewable_impressions`]),
          charCount: 3
        }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [_createVNode(_component_dot_element, {
          color: "#E9F6F6",
          size: 8
        }), _createTextVNode(" Non-Viewable impre. ")]), _createElementVNode("div", _hoisted_41, [_createVNode(_component_currency_value, {
          value: row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`],
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_non_viewable_impressions`],
          precision: row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`] > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"]), _createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`] / (row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_viewable_impressions`]),
          charCount: 3
        }, null, 8, ["value"])])])])])])]),
        default: _withCtx(() => [_createVNode(_component_bar_with_value, {
          value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] / (row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`]),
          min: 0,
          color: "#1EBDBD",
          max: 1,
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          "bar-append": _withCtx(() => [_hoisted_42]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] + row.item?.[`${_ctx.currentTabValue}_non_viewable_impressions`],
            loading: $props.loading,
            showSymbol: false,
            align: "right",
            allowPrecisionModification: false,
            charCount: $options.maxCharCount?.currency?.[`${_ctx.currentTabValue}_viewable_impressions`],
            precision: row.item?.[`${_ctx.currentTabValue}_viewable_impressions`] > 1000000 ? 1 : 0
          }, null, 8, ["value", "loading", "charCount", "precision"])]),
          _: 2
        }, 1032, ["value", "loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_vtr)": _withCtx(row => [_createVNode(_component_boxed_value, {
        bgColor: $options.getColorsBasedOnRange(row.item?.[`${_ctx.currentTabValue}_vtr`], [[[Number.NEGATIVE_INFINITY, 0.69], '#FFF0F1'], [[0.7, Number.POSITIVE_INFINITY], '#FFF']]),
        loading: $props.loading,
        styles: {
          justifyContent: `${Math.round(row.item?.[`${_ctx.currentTabValue}_vtr`] * 100) < 70 ? 'space-between' : 'flex-end'}`,
          gap: '2px'
        }
      }, {
        default: _withCtx(() => [Math.round(row.item?.[`${_ctx.currentTabValue}_vtr`] * 100) < 70 ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
          key: 0
        }, {
          title: _withCtx(() => [_hoisted_43]),
          content: _withCtx(() => [_hoisted_44]),
          default: _withCtx(() => [_createVNode(_component_app_icon, {
            icon: "info-circle",
            color: "#931A1F",
            size: 10,
            class: "dsp_vtr_info"
          })]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_vtr`]
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["bgColor", "loading", "styles"])]),
      "cell(dsp_delivery_rate)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_delivery_rate`],
          color: $options.getColorsBasedOnRange(row.item?.[`${_ctx.currentTabValue}_delivery_rate`], $data.DSP_DELIVERY_RATE_COLORS),
          styles: {
            background: $options.getColorsBasedOnRange(row.item?.[`${_ctx.currentTabValue}_delivery_rate`], $data.DSP_DELIVERY_RATE_BG_COLORS),
            padding: '1px 8px',
            borderRadius: '6px'
          }
        }, null, 8, ["value", "color", "styles"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_percent_ntb_cust)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_share_of_ntb`],
          color: $options.getColorsBasedOnRange(row.item?.[`${_ctx.currentTabValue}_share_of_ntb`], $data.DSP_NTB_CUSTOMERS_RATE_COLORS),
          styles: {
            background: $options.getColorsBasedOnRange(row.item?.[`${_ctx.currentTabValue}_share_of_ntb`], $data.DSP_NTB_CUSTOMERS_RATE_BG_COLORS),
            padding: '1px 8px',
            borderRadius: '6px'
          }
        }, null, 8, ["value", "color", "styles"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_cvr)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_cvr_dpv_click_to_purchase`],
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_post_click_purch)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading,
        style: {
          "justify-content": "right"
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_post_click_purchase_ratio`],
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_halo)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.[`${_ctx.currentTabValue}_halo_effect`],
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_consideration_signals)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        delay: {
          show: 0,
          hide: 100
        },
        width: 230,
        padding: "8px",
        class: "raos_vs_target_popover",
        customClass: "dsp-popover"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_45, [_createElementVNode("div", _hoisted_46, [_createTextVNode(" New Customers "), _createVNode(_component_currency_value, {
          value: row.item?.consideration_signals,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_signals,
          precision: row.item?.consideration_signals > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_47, [_createVNode(_component_bar_with_value, {
          value: row.item?.consideration_atc_clicks,
          min: Math.min($options.minMax?.consideration_signals?.min, $options.minMax?.consideration_atc_clicks?.min, $options.minMax?.consideration_atc_views?.min, $options.minMax?.consideration_dpv_clicks?.min, $options.minMax?.consideration_dpv_views?.min),
          color: "#BE510E",
          max: $options.minMax?.consideration_signals?.max,
          loading: $props.loading,
          height: 15,
          tight: "",
          style: {
            "width": "100%"
          }
        }, {
          "bar-append": _withCtx(() => [_createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.consideration_dpv_clicks / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
              borderRadius: '0 4px 4px 0',
              height: '15px',
              background: '#FCAF83'
            })
          }, null, 4), _createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.consideration_atc_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
              borderRadius: '0 4px 4px 0',
              height: '15px',
              background: '#FFCCAD'
            })
          }, null, 4), _createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.consideration_dpv_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
              borderRadius: '0 4px 4px 0',
              height: '15px',
              background: '#FFE9DB'
            })
          }, null, 4)]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"]), _createElementVNode("div", _hoisted_48, [_createElementVNode("div", _hoisted_49, [_createElementVNode("div", _hoisted_50, [_createVNode(_component_dot_element, {
          color: "#BE510E",
          size: 8
        }), _createTextVNode(" ATC Clicks ")]), _createElementVNode("div", _hoisted_51, [_createVNode(_component_currency_value, {
          value: row.item?.consideration_atc_clicks,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_atc_clicks,
          precision: row.item?.consideration_atc_clicks > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_52, [_createElementVNode("div", _hoisted_53, [_createVNode(_component_dot_element, {
          color: "#FCAF83",
          size: 8
        }), _createTextVNode(" DPV Clicks ")]), _createElementVNode("div", _hoisted_54, [_createVNode(_component_currency_value, {
          value: row.item?.consideration_dpv_clicks,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_dpv_clicks,
          precision: row.item?.consideration_dpv_clicks > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createVNode(_component_dot_element, {
          color: "#FFCCAD",
          size: 8
        }), _createTextVNode(" ATC Views ")]), _createElementVNode("div", _hoisted_57, [_createVNode(_component_currency_value, {
          value: row.item?.consideration_atc_views,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_atc_views,
          precision: row.item?.consideration_atc_views > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_58, [_createElementVNode("div", _hoisted_59, [_createVNode(_component_dot_element, {
          color: "#FFE9DB",
          size: 8
        }), _createTextVNode(" DPV Views ")]), _createElementVNode("div", _hoisted_60, [_createVNode(_component_currency_value, {
          value: row.item?.consideration_dpv_views,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_dpv_views,
          precision: row.item?.consideration_dpv_views > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])])])])])]),
        default: _withCtx(() => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`],
                charCount: $options.maxCharCount?.percentage?.[`consideration_signals_evol${$data.evolCategory[_ctx.periodCategory]}`],
                align: "right",
                tight: "",
                color: color
              }, null, 8, ["value", "charCount", "color"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.consideration_atc_clicks,
              min: Math.min($options.minMax?.consideration_signals?.min, $options.minMax?.consideration_atc_clicks?.min),
              color: "#F89053",
              max: $options.minMax?.consideration_signals?.max,
              loading: $props.loading,
              height: 15,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_createElementVNode("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.consideration_dpv_clicks / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                  borderRadius: '0 4px 4px 0',
                  height: '15px',
                  background: '#FCAF83'
                })
              }, null, 4), _createElementVNode("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.consideration_atc_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                  borderRadius: '0 4px 4px 0',
                  height: '15px',
                  background: '#FFCCAD'
                })
              }, null, 4), _createElementVNode("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.consideration_dpv_views / $options.minMax?.consideration_signals?.max * 100 ?? 0}%`,
                  borderRadius: '0 4px 4px 0',
                  height: '15px',
                  background: '#FFE9DB'
                })
              }, null, 4)]),
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.consideration_signals,
                loading: $props.loading,
                showSymbol: false,
                align: "right",
                allowPrecisionModification: false,
                charCount: $options.maxCharCount?.currency?.consideration_signals,
                precision: row.item?.consideration_signals > 1000000 ? 1 : 0
              }, null, 8, ["value", "loading", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_dpvr_vs_target)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        width: 124,
        padding: "8px",
        class: "raos_vs_target_popover"
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_61, "Target ROAS: " + _toDisplayString(row.item?.consideration_target), 1)]),
        content: _withCtx(() => [_createElementVNode("div", _hoisted_62, _toDisplayString(row.item?.consideration_target > row.item?.consideration_dpvr ? 'Below Target' : 'Above Target'), 1)]),
        default: _withCtx(() => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_overlap_bar_value, {
            value: row.item?.consideration_dpvr,
            background: "",
            borderColor: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '#DEFBE6' : '#FFF0F1'}`,
            min: 0,
            max: Math.max($options.minMax?.consideration_dpvr?.max, $options.minMax?.consideration_target?.max),
            loading: $props.loading,
            align: "left",
            barStyles: {
              borderRight: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '1.2px solid #22863D ' : '1.2px solid #E7747A'}`,
              borderRadius: '4px',
              height: '20px',
              background: `${row.item?.consideration_dpvr >= row.item?.consideration_target ? '#DEFBE6' : '#FFF0F1'}`
            },
            style: {
              "width": "100%",
              "position": "absolute",
              "z-index": "1"
            }
          }, {
            default: _withCtx(() => [_createVNode(_component_number_value, {
              value: row.item?.consideration_dpvr,
              charCount: $options.maxCharCount?.number?.consideration_dpvr,
              precision: 1,
              tight: ""
            }, null, 8, ["value", "charCount"])]),
            _: 2
          }, 1032, ["value", "borderColor", "max", "loading", "barStyles"]), _createVNode(_component_overlap_bar_value, {
            value: row.item?.consideration_target,
            background: "",
            borderColor: "#E3E3E3",
            min: 0,
            max: Math.max($options.minMax?.consideration_dpvr?.max, $options.minMax?.consideration_target?.max),
            loading: $props.loading,
            align: "left",
            barStyles: {
              borderRight: 'none',
              borderRadius: '4px',
              height: '20px',
              background: '#E3E3E3'
            },
            style: {
              "width": "100%",
              "position": "absolute"
            }
          }, null, 8, ["value", "max", "loading"])]),
          _: 2
        }, 1032, ["loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_cpa_consideration)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "right",
          value: row.item?.consideration_cpa_signal,
          precision: 2,
          charCount: $options.maxCharCount?.currency?.consideration_cpa_signal + 2
        }, null, 8, ["value", "charCount"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_dpv)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.consideration_dpv,
        background: "",
        borderColor: "#ADCDFF",
        min: Math.min($options.minMax?.consideration_spend?.min, $options.minMax?.consideration_dpv?.min),
        max: Math.max($options.minMax?.consideration_spend?.max, $options.minMax?.consideration_dpv?.max),
        loading: $props.loading,
        align: "left",
        styles: {
          padding: '0 8px 0 1px'
        },
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#ADCDFF'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          value: row.item?.consideration_dpv,
          loading: $props.loading,
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_dpv,
          precision: row.item?.consideration_dpv > 1000000 ? 1 : 0,
          valueAlign: "left"
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_atc)": _withCtx(row => [_createVNode(_component_overlap_bar_value, {
        value: row.item?.consideration_atc,
        background: "",
        borderColor: "#E3EDF7",
        min: $options.minMax?.consideration_atc?.min,
        max: $options.minMax?.consideration_atc?.max,
        loading: $props.loading,
        align: "left",
        barStyles: {
          borderLeft: 'none',
          borderRadius: '4px',
          height: '22px',
          background: '#E3EDF7'
        },
        class: "purchase-share-bar"
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "left",
          value: row.item?.consideration_atc,
          loading: $props.loading,
          showSymbol: false,
          align: "left",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.consideration_atc,
          precision: row.item?.consideration_atc > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]),
        _: 2
      }, 1032, ["value", "min", "max", "loading"])]),
      "cell(dsp_percent_dpv_click)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.consideration_dpv_click_ratio,
          precision: 1
        }, null, 8, ["value"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_repurchases)": _withCtx(row => [_createVNode(_component_wrap_with_popover, {
        delay: {
          show: 0,
          hide: 100
        },
        width: 230,
        padding: "8px",
        class: "raos_vs_target_popover",
        customClass: "dsp-popover"
      }, {
        content: _withCtx(() => [_createElementVNode("div", _hoisted_63, [_createElementVNode("div", _hoisted_64, [_createTextVNode(" New Customers "), _createVNode(_component_currency_value, {
          value: row.item?.loyalty_repurchases,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.loyalty_repurchases,
          precision: row.item?.loyalty_repurchases > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])]), _createElementVNode("div", _hoisted_65, [_createVNode(_component_bar_with_value, {
          value: row.item?.loyalty_sns,
          min: Math.min($options.minMax?.loyalty_repurchases?.min, $options.minMax?.loyalty_sns?.min),
          color: "#F89053",
          max: $options.minMax?.loyalty_repurchases?.max,
          loading: $props.loading,
          height: 15,
          tight: "",
          style: {
            "width": "100%"
          }
        }, {
          "bar-append": _withCtx(() => [_createElementVNode("div", {
            class: "bar-background",
            style: _normalizeStyle({
              width: `${row.item?.loyalty_purchases / $options.minMax?.loyalty_repurchases?.max * 100 ?? 0}%`,
              borderRadius: '0 4px 4px 0',
              height: '15px',
              background: '#FFE9DB'
            })
          }, null, 4)]),
          _: 2
        }, 1032, ["value", "min", "max", "loading"]), _createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("div", _hoisted_68, [_createVNode(_component_dot_element, {
          color: "#F89053",
          size: 8
        }), _createTextVNode(" SnS customers ")]), _createElementVNode("div", _hoisted_69, [_createVNode(_component_currency_value, {
          value: row.item?.loyalty_sns,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.loyalty_sns,
          precision: row.item?.loyalty_sns > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])]), _createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createVNode(_component_dot_element, {
          color: "#FFE9DB",
          size: 8
        }), _createTextVNode(" Single purchase ")]), _createElementVNode("div", _hoisted_72, [_createVNode(_component_currency_value, {
          value: row.item?.loyalty_purchases,
          loading: $props.loading,
          showSymbol: false,
          align: "right",
          allowPrecisionModification: false,
          charCount: $options.maxCharCount?.currency?.loyalty_purchases,
          precision: row.item?.loyalty_purchases > 1000000 ? 1 : 0
        }, null, 8, ["value", "loading", "charCount", "precision"])])])])])])]),
        default: _withCtx(() => [_createVNode(_component_hug_value, {
          loading: $props.loading,
          style: {
            "position": "relative"
          }
        }, {
          default: _withCtx(() => [_createVNode(_component_slot_with_evolution_value, {
            gap: 8
          }, {
            evolution: _withCtx(() => [_createVNode(_component_evolution_value, {
              value: row.item?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`]
            }, {
              default: _withCtx(({
                color
              }) => [_createVNode(_component_percentage_value, {
                value: row.item?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`],
                charCount: $options.maxCharCount?.percentage?.[`${_ctx.currentTabValue}_new_customers_evol${$data.evolCategory[_ctx.periodCategory]}`],
                align: "right",
                tight: "",
                color: color
              }, null, 8, ["value", "charCount", "color"])]),
              _: 2
            }, 1032, ["value"])]),
            default: _withCtx(() => [_createVNode(_component_bar_with_value, {
              value: row.item?.loyalty_sns,
              min: Math.min($options.minMax?.loyalty_repurchases?.min, $options.minMax?.loyalty_sns?.min),
              color: "#F89053",
              max: $options.minMax?.loyalty_repurchases?.max,
              loading: $props.loading,
              height: 15,
              tight: ""
            }, {
              "bar-append": _withCtx(() => [_createElementVNode("div", {
                class: "bar-background",
                style: _normalizeStyle({
                  width: `${row.item?.loyalty_purchases / $options.minMax?.loyalty_repurchases?.max * 100 ?? 0}%`,
                  borderRadius: '0 4px 4px 0',
                  height: '15px',
                  background: '#FFE9DB'
                })
              }, null, 4)]),
              default: _withCtx(() => [_createVNode(_component_currency_value, {
                value: row.item?.loyalty_repurchases,
                loading: $props.loading,
                showSymbol: false,
                align: "right",
                allowPrecisionModification: false,
                charCount: $options.maxCharCount?.currency?.loyalty_repurchases,
                precision: row.item?.loyalty_repurchases > 1000000 ? 1 : 0
              }, null, 8, ["value", "loading", "charCount", "precision"])]),
              _: 2
            }, 1032, ["value", "min", "max", "loading"])]),
            _: 2
          }, 1024)]),
          _: 2
        }, 1032, ["loading"])]),
        _: 2
      }, 1024)]),
      "cell(dsp_cpa_loyalty)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_currency_value, {
          valueAlign: "right",
          value: row.item?.loyalty_cpa_repurchase,
          precision: 2,
          charCount: $options.maxCharCount?.currency?.loyalty_cpa_repurchase + 2
        }, null, 8, ["value", "charCount"])]),
        _: 2
      }, 1032, ["loading"])]),
      "cell(dsp_percent_existing_cust)": _withCtx(row => [_createVNode(_component_hug_value, {
        loading: $props.loading
      }, {
        default: _withCtx(() => [_createVNode(_component_percentage_value, {
          value: row.item?.loyalty_share_of_existing_customers,
          color: $options.getColorsBasedOnRange(row.item?.loyalty_share_of_existing_customers, $data.DSP_NTB_CUSTOMERS_RATE_COLORS),
          styles: {
            background: $options.getColorsBasedOnRange(row.item?.loyalty_share_of_existing_customers, $data.DSP_NTB_CUSTOMERS_RATE_BG_COLORS),
            padding: '1px 8px',
            borderRadius: '6px'
          }
        }, null, 8, ["value", "color", "styles"])]),
        _: 2
      }, 1032, ["loading"])]),
      _: 2
    }, 1032, ["class", "style", "items", "fields", "tbodyTrClass", "onHeadClicked", "onRowClicked", "fieldColumnClass"])]),
    _: 1
  }, 8, ["datePickerDate", "loading", "onChangeDate", "onTableState", "page", "totalPages", "perPage", "fields", "selectedPeriod"]);
}